import { styled, Box, BoxProps } from '@mui/material';

import { openSidebarWidth, masqueradingFooterHeight } from 'shared/constants/styles';

const customInputProps = ['fixedWidth', 'extraMarginBottom'] as PropertyKey[];

export const Wrapper = styled(Box, {
  shouldForwardProp: (propName: PropertyKey) => !customInputProps.includes(propName)
})<BoxProps & { fixedWidth: boolean; extraMarginBottom: boolean }>`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: ${({ theme }) => theme.spacing(3)};

  ${({ extraMarginBottom }) =>
    extraMarginBottom && { marginBottom: `${masqueradingFooterHeight}px` }}

  ${({ theme }) => theme.breakpoints.down('md')} {
    padding: ${({ theme }) => theme.spacing(2)};
  }

  ${({ theme }) => theme.breakpoints.up('lg')} {
    ${({ fixedWidth, theme }) =>
      fixedWidth && {
        maxWidth: `calc(${theme.breakpoints.values.xl}px - ${openSidebarWidth}px)`,
        alignSelf: 'center',
        width: '100%'
      }}
  }
`;
